import React, { useEffect, useState } from "react"
import { Box, Button, Divider, Grid, Typography, Paper } from "@mui/material"
import { exportExcel } from "../utils/functions"
import { FileDownload } from "@mui/icons-material"
import { getCasesDashboard, getEvalCasesDashboard, getAvalDashboard, getAvalCatDashboard } from "../data/retriever"

const Admin = () => {
    const [loading, setLoading] = useState(false)
    const [casesDash, setCasesDash] = useState("")
    const [evalCasesDash, setEvalCasesDash] = useState("")
    const [evalAvalDash, setEvalAvalDash] = useState([])
    const [evalAvalCatDash, setEvalAvalCatDash] = useState([])
    const [amountSent, setAmountSent] = useState(0)
    const [amountGP, setAmountGP] = useState(0)
    const [appGP, setAppGP] = useState(0)
    const [rejGP, setRejGP] = useState(0)
    const [appAMT, setAppAMT] = useState(0)
    const [rejAMT, setRejAMT] = useState(0)
    const [amountAMT, setAmountAMT] = useState(0)
    const [amountEval, setAmountEval] = useState(0)

    const getCasesDash= async () => {
        setLoading(true)
        const cases= await getCasesDashboard()
        const evalCases= await getEvalCasesDashboard()
        const evalAval = await getAvalDashboard()
        const evalAvalCat = await getAvalCatDashboard()

        setCasesDash(cases)
        setEvalCasesDash(evalCases)
        setEvalAvalDash(evalAval)
        setEvalAvalCatDash(evalAvalCat)

        const casesGP = cases?.filter((item)=> item.aprovado_gp != null)
        setAppGP(casesGP?.filter((item)=> item.aprovado_gp == 1).length)
        setRejGP(casesGP?.filter((item)=> item.aprovado_gp == 0).length)

        const casesAMT = cases?.filter((item)=> item.aprovado_amt != null)
        setAppAMT(casesAMT?.filter((item)=> item.aprovado_amt == 1).length)
        setRejAMT(casesAMT?.filter((item)=> item.aprovado_amt == 0).length)

        setAmountSent(cases.length)
        setAmountGP(casesGP.length)
        setAmountAMT(casesAMT.length)

        const uniqueEvalCases = evalCases?.filter((ccase, index) => 
            index == evalCases.findIndex((item) => 
                item.idAnexo == ccase.idAnexo
            )
        )
        setAmountEval(uniqueEvalCases.length || 0)
        setLoading(false)
    }

    useEffect(() => {
        getCasesDash()
    }, [])

    const AvaliadoresComp = ({ lista }) => {
        console.log("lista", lista)
        return (
            <Box padding={2}>
                <Typography align="center" variant="h6" textTransform="uppercase">{"Desempenho Avaliadores"}</Typography>
                <Grid container spacing={2}>
                    {lista.map((item, idx) => (
                        <Grid item xs={12} md={4} key={idx}>
                            <Paper
                                elevation={3} // sombra
                                sx={{ borderRadius: 2, padding: 2 }} // arredondado + espaçamento interno
                            >
                                <Typography variant="body2" textTransform="uppercase">{item.avaliador}</Typography>
                                <Typography variant="h6" className="valueAdmin">{`Casos pendentes: ${item.total_casos_aguardando}`}</Typography>
                                <Typography variant="h6" className="valueAdmin">{`Casos avaliados: ${item.total_casos_avaliados}`}</Typography>
                                <Typography sx={{ minHeight: "25px" }} variant="subtitle1" className="totalValueAdmin">{`Médicos vinculados: ${item.total_medicos}`}</Typography>
                                <Divider sx={{ borderColor: "pink" }} />
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }

    const DescComp = ({title, value, totalValue, obs}) => {
        return (
            <Box padding={2}>
                <Typography variant="body2" textTransform="uppercase">
                    {title}
                </Typography>
                <Typography variant="h5" className="valueAdmin" >
                    {value}
                    {totalValue && 
                    <>
                    <Typography variant="h6" className="totalValueAdmin">
                        {` / ${totalValue}`}
                    </Typography>
                    </>
                    }
                </Typography>
                <Typography sx={{minHeight:"25px"}} variant="subtitle1" className="totalValueAdmin">
                    {obs}
                </Typography>
                <Divider sx={{borderColor:"pink"}}/>
            </Box>
        )
    }
    return (    
        <Box className="mainBox admin">
            <Grid container item sm={12}>
                <Typography variant="h6" textTransform="uppercase" >
                    {"Casos clínicos"}
                </Typography>
            </Grid>
            {loading && 
                <Grid container   >

                    <Grid item xs={12} >
                    <div className="skeleton skeleton-header"></div>
                    <div className="skeleton skeleton-line"></div>
                    <div className="skeleton skeleton-line"></div>
                    <div className="skeleton skeleton-line"></div>
                    <div className="skeleton skeleton-line"></div>
                    <Typography
                        variant="h6"
                        color="gray"
                        >
                        Buscando dados...
                    </Typography>
                    </Grid>
                    
                </Grid>
            }
            {!loading && 
            <>
                <Grid container >
                    <Grid  item sm={6} >
                        <DescComp {...{title: "Total submetidos", value: amountSent}}/> 
                    </Grid>
                    <Grid  item sm={6} >
                        <DescComp {...{
                            title: "Total Validados - Gerente Projeto", 
                            value: amountGP, 
                            totalValue: amountSent,
                            obs: `[ ${appGP} APROVADOS - ${rejGP} REJEITADOS ]`
                            }}/> 
                    </Grid>
                
                    <Grid item sm={6} >
                        <DescComp {...{
                            title: "Total Validados - Área Médica", 
                            value: amountAMT, 
                            totalValue: appGP,
                            obs: `[ ${appAMT} APROVADOS - ${rejAMT} REJEITADOS ]`
                            }}/> 
                    </Grid>
                    <Grid item sm={6} >
                        <DescComp {...{title: "Total Avaliados com Notas - Avaliadores", value: amountEval, totalValue: appAMT}}/> 
                    </Grid>
                    <Grid item sm={12} >
                        <AvaliadoresComp lista={Array.isArray(evalAvalDash) ? evalAvalDash : []} />
                    </Grid>
                    <Button className="adminButton" 
                        onClick={()=>{
                            exportExcel({casesDash, evalCasesDash, evalAvalDash, evalAvalCatDash})
                        }} 
                        sx={{gap:1}}
                        >
                        <FileDownload fontSize="small"/>
                        <Typography variant="body2">
                        {"Download Excel"}           
                        </Typography>
                    </Button> 
                </Grid>
            </>}
            {/* <Grid container item sm={12}>
                <Typography variant="h6" textTransform="uppercase" >
                    {"Ranking - Notas"}
                </Typography>
            </Grid>   */}

                 
        </Box>
    )
}
export default Admin
